const initialState: MBChannelDetailsFormState = {
  name: '',
  description: '',
  imageUrl: null,
  emoji: '',
  isImageUploading: false,
  hasWorkflowTemplate: false,
  workflowTemplateName: '',
};

export function channelDetailsFormReducer(
  state: MBChannelDetailsFormState = initialState,
  action: ChannelDetailsFormAction,
): MBChannelDetailsFormState {
  switch (action.type) {
    case 'CHANNEL:DETAILS:UPDATE_NAME': {
      const { name } = action.value;
      return { ...state, name };
    }
    case 'CHANNEL:DETAILS:UPDATE_DESCRIPTION': {
      const { description } = action.value;
      return { ...state, description };
    }
    case 'CHANNEL:DETAILS:UPDATE_IMAGE_URL': {
      const { imageUrl } = action.value;
      return { ...state, imageUrl };
    }
    case 'CHANNEL:DETAILS:UPDATE_EMOJI': {
      const { emoji } = action.value;
      return { ...state, emoji };
    }
    case 'CHANNEL:DETAILS:UPDATE_IS_IMAGE_UPLOADING': {
      const { isImageUploading } = action.value;
      return { ...state, isImageUploading };
    }
    case 'CHANNEL:DETAILS:UPDATE_WORKFLOW_TEMPLATE_NAME': {
      const { workflowTemplateName } = action.value;
      return { ...state, workflowTemplateName };
    }
    case 'CHANNEL:DETAILS:SET_DETAILS': {
      const { details } = action.value;
      return { ...state, ...details };
    }
    case 'CHANNEL:DETAILS:RESET': {
      return initialState;
    }
    default:
      return state;
  }
}
